import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { SITE } from "@/config/siteConfig";

export default function ConditionsGenerales() {
  return (
    <LegalLayout title="Conditions générales" updatedAt="août 2026" testId="terms-page">
      <p className="rounded-2xl border border-jeem-yellow/60 bg-jeem-yellow/10 p-4 text-sm">
        Ce document est un modèle inspiré des pratiques courantes des fournisseurs de services de télécommunications au Québec (notamment le Code des services sans fil du CRTC et la Loi sur la protection du consommateur). Faites-le valider par un professionnel avant publication officielle.
      </p>

      <LegalSection title="1. Objet">
        <p>
          Les présentes conditions générales régissent l'utilisation du site web de {SITE.companyName} et les demandes de service effectuées par l'intermédiaire de ce site, du formulaire de contact ou de WhatsApp. Les conditions spécifiques applicables à chaque service (mobile, Internet, téléphonie, TV) vous sont confirmées par un conseiller avant toute activation.
        </p>
      </LegalSection>

      <LegalSection title="2. Services offerts">
        <p>
          {SITE.companyName} offre des services de télécommunications : forfaits mobiles, Internet très haut débit, téléphonie et télévision. Les caractéristiques présentées sur ce site (données, vitesses, avantages) sont fournies à titre indicatif et peuvent varier selon votre région et l'offre en vigueur au moment de votre demande.
        </p>
      </LegalSection>

      <LegalSection title="3. Prix et tarification">
        <p>
          Les prix ne sont pas affichés sur ce site. Les tarifs applicables vous sont communiqués par un conseiller sur WhatsApp ou par téléphone avant toute souscription, conformément aux pratiques de transparence tarifaire du Code des services sans fil du CRTC. Aucun frais ne vous est facturé sans votre consentement explicite.
        </p>
      </LegalSection>

      <LegalSection title="4. Sans contrat et résiliation">
        <p>
          Sauf indication contraire confirmée par écrit, nos forfaits sont sans contrat à durée déterminée. Vous pouvez donc modifier ou annuler votre service en nous contactant, sans frais de résiliation anticipée liés à une durée minimale. Les conditions exactes vous sont confirmées avant l'activation.
        </p>
      </LegalSection>

      <LegalSection title="5. Demandes via WhatsApp et formulaire">
        <p>
          L'envoi d'une demande via WhatsApp ou via le formulaire de contact ne constitue pas un contrat. Une entente n'est conclue qu'après validation de votre identité, confirmation de l'offre applicable et acceptation des conditions spécifiques du service avec un conseiller.
        </p>
      </LegalSection>

      <LegalSection title="6. Responsabilités">
        <p>
          {SITE.companyName} déploie des efforts raisonnables pour maintenir l'exactitude des informations de ce site, mais ne peut garantir l'absence d'erreurs ou d'omissions. Les images, témoignages ou exemples présentés à titre illustratif sont identifiés comme tels.
        </p>
      </LegalSection>

      <LegalSection title="7. Lois applicables">
        <p>
          Les présentes conditions sont régies par les lois de la province de Québec et du Canada, incluant la Loi sur la protection du consommateur et les règlements du CRTC. Tout litige sera soumis aux tribunaux compétents du district de Montréal.
        </p>
      </LegalSection>

      <LegalSection title="8. Nous joindre">
        <p>
          Pour toute question au sujet de ces conditions : <a className="font-semibold text-black underline decoration-jeem-yellow decoration-2 underline-offset-2" href={`mailto:${SITE.email}`}>{SITE.email}</a> • {SITE.phone} • {SITE.address}
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
